<template>
  <div class="LINEMESSAGE-BOX" v-if="item.contents.length>0" :style="[
    {
      display: 'flex',
      flexDirection: item.layout === 'vertical' ? 'column' : 'row',
      alignItems: item.layout === 'baseline' ? 'baseline' :item.alignItems,
      justifyContent: item.justifyContent
    },
    item.flex ? { flex: item.flex } : {},
    item.background?{
      background: item.background
    }:{ backgroundColor: item.backgroundColor },
    item.paddingAll?{
      padding: item.paddingAll
    }:{},
    item.paddingTop?{ paddingTop: item.paddingTop}:{},
    item.paddingStart?{ paddingTop: item.paddingStart}:{},
    item.paddingBottom?{ paddingTop: item.paddingBottom}:{},
    item.paddingEnd?{ paddingTop: item.paddingEnd}:{},
    item.margin?{
      marginTop: item.margin === 'xs' ? '2px'
      : item.margin === 'sm' ? '4px'
      : item.margin === 'md' ? '8px'
      : item.margin === 'lg' ? '12px'
      : item.margin === 'lg' ? '12px'
      : item.margin === 'xl' ? '16px'
      : item.margin === 'xxl' ? '20px'
      : item.margin
    }:{},
    item.borderWidth?{
      borderWidth: item.borderWidth,
      borderStyle: 'solid'
    }:{},
    item.borderColor?{
      borderColor: item.borderColor
    }:{},
    item.spacing?{
      gap: item.spacing === 'xs' ? '2px'
      : item.spacing === 'sm' ? '4px'
      : item.spacing === 'md' ? '8px'
      : item.spacing === 'lg' ? '12px'
      : item.spacing === 'lg' ? '12px'
      : item.spacing === 'xl' ? '16px'
      : item.spacing === 'xxl' ? '20px'
      : item.spacing
    }:{},
    { position: item.position || 'relative' },
    item.position==='absolute'?{
      top: item.offsetTop,
      bottom: item.offsetBottom,
      left: item.offsetStart,
      right: item.offsetEnd,
      alignItems: 'center',
      justifyContent: 'center'
    }:{},
    item.height?{ height: item.height}:{},
    item.width?{ width: item.width}:{width: '-webkit-fill-available'},
    item.cornerRadius?{
      borderRadius: item.cornerRadius
    }:{}
  ]">
    <template  v-for="(row, r) in item.contents">
      <Selector v-if="row" :item="row" :index="r" :key="r">
      </Selector>
    </template>
  </div>
</template>

<script>
import Selector from './Selector.vue'
export default {
  name: 'boxcube',
  props: ['item'],
  components: { Selector }
  // props: {
  //   contents: {
  //     type: Array,
  //     default () {
  //       return []
  //     }
  //   },
  //   type: {
  //     type: String,
  //     default: 'box'
  //   },
  //   layout: {
  //     type: String,
  //     default: 'vertical'
  //   },
  //   backgroundColor: {
  //     type: String,
  //     default: '#00000000',
  //     placeholder: '#RRGGBBAA'
  //   },
  //   borderColor: {
  //     type: String,
  //     default: '#00000000',
  //     placeholder: '#RRGGBBAA'
  //   },
  //   borderWidth: {
  //     type: String,
  //     default: 'none',
  //     placeholder: '__px / none / normal / medium / semi-bold / bold / listed in order of increasing width'
  //   },
  //   cornerRadius: {
  //     type: String,
  //     default: 'none',
  //     placeholder: '__px / none / xs / sm / md / lg / xl / xxl'
  //   },
  //   width: {
  //     type: String,
  //     default: 'none',
  //     placeholder: '__px | __% if set => flex = 0'
  //   },
  //   maxWidth: {
  //     type: String,
  //     default: 'none',
  //     placeholder: '__px | __% '
  //   },
  //   height: {
  //     type: String,
  //     default: 'none',
  //     placeholder: '__px | __% if set => flex = 0'
  //   },
  //   maxHeight: {
  //     type: String,
  //     default: 'aut',
  //     placeholder: '__px | __% '
  //   },
  //   flex: {
  //     type: Number,
  //     default: 0,
  //     placeholder: '數字比例'
  //   },
  //   spacing: {
  //     type: String,
  //     default: 'none',
  //     placeholder: '+__px / none / xs / sm / md / lg / xl / xxl'
  //   },
  //   margin: {
  //     type: String,
  //     default: 'none',
  //     placeholder: '+__px / none / xs / sm / md / lg / xl / xxl'
  //   },
  //   paddingAll: {
  //     type: String,
  //     default: null,
  //     placeholder: '__px / __% / none / xs / sm / md / lg / xl / xxl'
  //   },
  //   position: {
  //     type: String,
  //     default: 'relative',
  //     options: ['relative', 'absolute']
  //   },
  //   offsetTop: {
  //     type: String,
  //     default: 'none',
  //     placeholder: '__px / __% / none / xs / sm / md / lg / xl / xxl'
  //   },
  //   offsetBottom: {
  //     type: String,
  //     default: 'none',
  //     placeholder: '__px / __% / none / xs / sm / md / lg / xl / xxl'
  //   },
  //   offsetStart: {
  //     type: String,
  //     default: 'none',
  //     placeholder: '__px / __% / none / xs / sm / md / lg / xl / xxl'
  //   },
  //   offsetEnd: {
  //     type: String,
  //     default: 'none',
  //     placeholder: '__px / __% / none / xs / sm / md / lg / xl / xxl'
  //   },
  //   justifyContent: {
  //     type: String,
  //     default: 'flex-start',
  //     options: ['flex-start', 'flex-end', 'space-between', 'space-around', 'space-evenly']
  //   },
  //   alignItems: {
  //     type: String,
  //     default: 'flex-start',
  //     options: ['flex-start', 'flex-end', 'center']
  //   },
  //   background: {
  //     type: {
  //       type: String,
  //       default: null,
  //       options: [null, 'linearGradient']
  //     },
  //     angle: {
  //       type: String,
  //       placeholder: '__deg [0, 360)',
  //       required: 'background.type === "linearGradient"'
  //     },
  //     startColor: {
  //       type: String,
  //       default: null,
  //       placeholder: '#RRGGBBAA | #RRGGBB',
  //       required: 'background.type === "linearGradient"'
  //     },
  //     endColor: {
  //       type: String,
  //       default: null,
  //       placeholder: '#RRGGBBAA | #RRGGBB',
  //       required: 'background.type === "linearGradient"'
  //     },
  //     centerColor: {
  //       type: String,
  //       default: null,
  //       placeholder: '#RRGGBBAA | #RRGGBB',
  //       required: 'background.type === "linearGradient"'
  //     },
  //     centerPosition: {
  //       type: String,
  //       default: '50%',
  //       placeholder: '#RRGGBBAA | #RRGGBB',
  //       required: '(0%, 100%)'
  //     }
  //   }
  // }

}
</script>

<style lang="scss">
* {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    border: 0 solid transparent;
    font-size: 100%;
    font-weight: normal;
    font-style: normal;
    list-style: none;
}
.LyNa {
  width: 100%;
  max-width: 120px;
  min-width: 0;
  .T1 {
    border-radius: 10px;
  }
}
.LyMi {
  width: 100%;
  max-width: 160px;
  min-width: 0;
  .T1 {
    border-radius: 10px;
  }
}
.LyDe {
  width: 100%;
  max-width: 220px;
  min-width: 0;
  .T1 {
    border-radius: 10px;
  }
}
.LyHe {
  width: 100%;
  max-width: 241px;
  min-width: 0;
  .T1 {
    border-radius: 10px;
  }
}
.LyKi {
  width: 100%;
  max-width: 260px;
  min-width: 0;
  .T1 {
    border-radius: 10px;
  }
}
.LyMe {
  width: 100%;
  max-width: 300px;
  min-width: 0;
  .T1 {
    border-radius: 17px;
  }
}
.LyGi {
  width: 100%;
  max-width: 386px;
  min-width: 0;
  .T1 {
    border-radius: 5px;
  }
}
</style>
